import { Injectable } from '@angular/core';
import * as jsPDF from 'jspdf';
import * as XLSX from 'xlsx';
import * as FileSaver from 'file-saver';
import { DateHandlerService } from './date-handler.service';
import {formatDate} from '@angular/common';
import {Travel} from '../models/travel';
import {Refill} from '../models/refill';
import {SnackBarHandlerService} from './snack-bar-handler.service';

@Injectable()
export class ExportXLSPDF {

	EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
	EXCEL_EXTENSION = '.xlsx';

	constructor(
    private dateHandler: DateHandlerService,
    private snackBarHandler: SnackBarHandlerService
		) {}

	exportXLSX(data) {
		/* this.travel.getTravelsCount(user.id).then(count => {
      this.travel.getAllTravel(user, count.toString()).then(data => { */
		const newJson = [];
		data.forEach((travel: Travel) => {

      let routesCSV: string = '';
      if(travel.route && travel.route.length !== 0) {
        try {
          const routes: any[] = JSON.parse(travel.route);
          for(let i = 0 ; i < routes.length; i++) {
            routesCSV += '(' + routes[i].da + ' - ' + routes[i].a + ')'
            if(routes[i].ar) {
              routesCSV += ' [A/R]';
            }
          }
        } catch (error: any) {
          this.snackBarHandler.showSnackbar('Attenzione problema nel JSON travel.route --' + error, 3000);
        }
      }

			const json = {
        'ID viaggio' : travel.id,
        Richiedente : travel.user.name + ' ' + travel.user.surname,
				Motivazione: this.determineMotivationOther(travel),
				'Altri guidatori': travel.other_drivers,
				'Richiesta da': this.dateHandler.formatDateClassic(travel.required_from) + ' ' +
				this.dateHandler.formatTimeClassic(travel.required_from),
				'Richiesta a': this.dateHandler.formatDateClassic(travel.required_to) + ' ' +
				this.dateHandler.formatTimeClassic(travel.required_to),
        'Inizio viaggio': this.dateHandler.formatDateClassic(travel.started_at) + ' ' +
				this.dateHandler.formatTimeClassic(travel.started_at),
        'Fine viaggio': this.dateHandler.formatDateClassic(travel.ended_at) + ' ' +
				this.dateHandler.formatTimeClassic(travel.ended_at),
				Targa: travel.vehicle.plate,
				Marca: travel.vehicle.model.brand.name,
				Modello: travel.vehicle.model.name,
				Classe: travel.vehicle.type.name,
				Superclasse: travel.vehicle.type.supertype.name,
				Parco: travel.vehicle.park.name,
				'Chilometri iniziali': travel.start_kilometers,
				'Chilometri finali': travel.end_kilometers,
        'Chilometri totale': travel.start_kilometers && travel.end_kilometers ? (+travel.end_kilometers - +travel.start_kilometers).toString() : '',
        'Autorizzato da': travel.admin.id ? travel.admin.name + ' ' + travel.admin.surname : '',
				Segnalazioni: travel.reporting,
        Itinerario: routesCSV
			};

			newJson.push(json);
		});
		const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(newJson);
		const workbook: XLSX.WorkBook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
		worksheet.C1.t = Date;
		const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
		this.saveAsExcelFile(excelBuffer, 'viaggi');
		/* });
  }); */
	}

	exportRef(data) {
		/*  this.refill.getRefillsCount(user.id).then(count => {
       this.refill.getAllRefills(user, count.toString()).then(data => { */
		const newJson = [];
		data.forEach(refuel => {
			const json = {
        'idRifornimento': refuel.id,
				'Nome': refuel.travel.user.name,
				'Cognome': refuel.travel.user.surname,
				'Data': this.dateHandler.formatDateClassic(refuel.made_at),
				'Ora': this.dateHandler.formatTimeClassic(refuel.made_at),
				'Targa': refuel.travel.vehicle.plate,
				'Chilometri': refuel.kilometers,
				'Costo(€)': refuel.amount,
				'Quantità(lt)': refuel.quantity
			};
			newJson.push(json);
		});
		const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(newJson);
		const workbook: XLSX.WorkBook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
		worksheet.C1.t = Date;
		const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
		this.saveAsExcelFile(excelBuffer, 'rifornimenti');
		/* });
  }); */
	}

	exportAuto(list) {
		console.log('park: ', list);
		const newJson = [];
		list.forEach(auto => {
			const json = {
				Targa: auto.plate,
				Numero_Viaggi: auto.travels,
				Rifornimenti_Approvati: auto.approved,
				Rifornimenti_Rifiutati: auto.pending,
				Rifornimenti_Pendenti: auto.refused,
				Stato_Serbatoio: auto.last_fuel_level ? auto.last_fuel_level : 0,
				Rapporto_km_lt: auto.chilometri_litro ? (Math.round(auto.chilometri_litro * 100) / 100) : 0,
        Chilometraggio: auto.utlimi_chilometri ? +auto.utlimi_chilometri : 0
			};
			newJson.push(json);
		});
		const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(newJson);
		const workbook: XLSX.WorkBook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
		worksheet.C1.t = Date;
		const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
		this.saveAsExcelFile(excelBuffer, 'parco_auto');
	}

	private saveAsExcelFile(buffer: any, fileName: string): void {
		const data: Blob = new Blob([buffer], {
			type: this.EXCEL_TYPE
		});
		FileSaver.saveAs(data, fileName + '_export_' + this.dateHandler.formatDateClassic(new Date()) + this.EXCEL_EXTENSION);
	}

	determineMotivationOther(travel): string {
    return travel.motivation === 3 ? travel.motivation_other : travel.motivation_name;
	  }

	showTravelPdf(travel: Travel,refills: Refill[], file) {

    const doc = new jsPDF();

    // BOX PRINCIPALE******************************************************************************
    doc.rect(10, 10, 190, 275);
    const fontName = 'helvetica';

    // *********HEADER************************************
    doc.setDrawColor(0);
    doc.setFillColor(204, 0, 0);
    doc.rect(10, 10, 190, 20, 'F');

    doc.setFont(fontName, 'normal');
    doc.setTextColor(255, 255, 255);

    doc.setFontSize(16);
    doc.text('CERTIFICAZIONE DI VIAGGIO N° ' + travel.id, 15,20, null, null, 'left');

    doc.setFont(fontName, 'italic');
    doc.setFontSize(9);
    doc.text('per la movimentazione di automezzi e natanti della Croce Rossa Italiana', 15,25, null, null, 'left');

    if (file) {
      doc.addImage(file, 'PNG', 180, 12, 17, 15);
    }

    // *********RIQUADRO 1 - DATI VIAGGIO****************
    doc.setTextColor(0, 0, 0);
    doc.setFont(fontName, 'normal');
    doc.setFontSize(9);

    const start_r1_y = 40;
    const offset_r1_y = 7;
    let current_r1_y = start_r1_y;
    //------------------------------------------------
    doc.text('Dati Conducente:', 20, current_r1_y);
    const userName = (travel.user) ? travel.user.name + ' ' + travel.user.surname : '';
    doc.text(userName, 70, current_r1_y);
    doc.line(20, current_r1_y  + 1 , 185, current_r1_y + 1);
    //------------------------------------------------
    current_r1_y = current_r1_y + offset_r1_y;
    doc.text('Viaggio Autorizzato da:', 20, current_r1_y);
    doc.text(travel.admin.name + ' ' + travel.admin.surname, 70, current_r1_y);
    doc.line(20, current_r1_y  + 1, 185, current_r1_y  + 1);
    //------------------------------------------------
    current_r1_y = current_r1_y + offset_r1_y;
    doc.text('Motivo del servizio:', 20, current_r1_y);
    if(travel.motivation === 3) {
      const motivationOther = travel.motivation_other ? this.rimuoviAccapo(travel.motivation_other) : '';
      doc.text(motivationOther, 70, current_r1_y);
    } else {
      doc.text(travel.motivation_name, 70, current_r1_y);
    }
    doc.line(20, current_r1_y  + 1, 185, current_r1_y  + 1);
    //------------------------------------------------
    current_r1_y = current_r1_y + offset_r1_y;
    doc.text('Targa veicolo CRI:', 20, current_r1_y);
    doc.text(travel.vehicle.plate, 70, current_r1_y);
    doc.line(20, current_r1_y  + 1, 185, current_r1_y  + 1);
    //------------------------------------------------
    current_r1_y = current_r1_y + offset_r1_y;
    doc.text('Targa rimorchio aggangiato CRI:', 20, current_r1_y);
    doc.text('', 70, current_r1_y);
    doc.line(20, current_r1_y  + 1, 185, current_r1_y  + 1);
    //------------------------------------------------
    current_r1_y = current_r1_y + offset_r1_y;
    doc.text('Persone trasportate:', 20, current_r1_y);
    const passengers = travel.passengers ? this.rimuoviAccapo(travel.passengers) : '';
    doc.text(passengers, 70, current_r1_y);
    doc.line(20, current_r1_y  + 1, 185, current_r1_y  + 1);
    //------------------------------------------------
    current_r1_y = current_r1_y + offset_r1_y;
    doc.text('Data Partenza:', 20, current_r1_y);
    const started_at = travel.started_at ? this.dateHandler.formatDateClassic(travel.started_at) : '';
    const hour_started_at = travel.started_at ? this.dateHandler.formatTimeClassic(travel.started_at) : '';
    doc.text(started_at + ' ' + hour_started_at , 70, current_r1_y);
    doc.line(20, current_r1_y  + 1, 185, current_r1_y  + 1);
    //------------------------------------------------
    current_r1_y = current_r1_y + offset_r1_y;
    doc.text('Data Arrivo:', 20, current_r1_y);
    const ended_at = travel.ended_at ? this.dateHandler.formatDateClassic(travel.ended_at) : '';
    const hour_ended_at = travel.ended_at ? this.dateHandler.formatTimeClassic(travel.ended_at) : '';
    doc.text(ended_at + ' ' + hour_ended_at, 70, current_r1_y);
    doc.line(20, current_r1_y  + 1, 185, current_r1_y  + 1);


    // *********RIQUADRO 2 - DATI DI VIAGGIO ****************
    // *** Header r2
    const start_header_r2_y = current_r1_y + 6;
    const height_header_r2 = 7;

    doc.setDrawColor(0);
    doc.setFillColor(204, 0, 0);
    doc.rect(10, start_header_r2_y, 190, height_header_r2, 'F');

    doc.setFont(fontName, 'normal');
    doc.setTextColor(255, 255, 255);

    doc.setFontSize(10);
    doc.text('DATI DI VIAGGIO', 12,start_header_r2_y + 5, null, null, 'left');

    // *** Dati r2
    doc.setTextColor(0, 0, 0);
    doc.setFont(fontName, 'normal');
    doc.setFontSize(9);
    const start_r2_y = start_header_r2_y + height_header_r2 + 7;
    const offset_r2_y = 9;
    let current_r2_y = start_r2_y;
    //------------------------------------------------

    // dati r2 - routes
    if(travel.route && travel.route.length !== 0) {
      try {
        const routes: any[] = JSON.parse(travel.route);
        for(let i = 0 ; i < routes.length; i++) {
          const tappaInt: number = i + 1;
          doc.text('TAPPA ' + tappaInt + ':', 20, current_r2_y);
          doc.text('DA: ' +  routes[i].da, 50, current_r2_y);
          doc.text('A: ' + routes[i].a, 120, current_r2_y);
          if(routes[i].ar) {
            doc.text('A/R', 175, current_r2_y);
          }
          current_r2_y = current_r2_y + offset_r2_y;
        }
      } catch (error: any) {
        this.snackBarHandler.showSnackbar('Attenzione problema nel JSON travel.route --' + error, 3000);
      }
    }

    //-----------------KM-----------------------------*/
    current_r2_y = current_r2_y + offset_r2_y + 5;
    const travelled_km= parseInt(travel.end_kilometers) - parseInt(travel.start_kilometers);
    doc.text(
      'KM INIZIALI '   + travel.start_kilometers  +
      '   ---   KM FINALI ' + travel.end_kilometers +
      '   ---   KM PERCORSI ' + travelled_km,
      105, current_r2_y,null,null,'center'
    );

    // *********RIQUADRO 3 - RIFORNIMENTI ****************
    // *** Header r2
    const start_header_r3_y = current_r2_y + 6;
    const height_header_r3 = 7;

    doc.setDrawColor(0);
    doc.setFillColor(204, 0, 0);
    doc.rect(10, start_header_r3_y, 190, height_header_r3, 'F');

    doc.setFont(fontName, 'normal');
    doc.setTextColor(255, 255, 255);

    doc.setFontSize(10);
    doc.text('RIFORNIMENTI', 12,start_header_r3_y + 5, null, null, 'left');

    // *** Dati r3 tabella rifornimenti
    doc.setTextColor(0, 0, 0);
    doc.setFont(fontName, 'normal');
    //doc.setFontSize(4);
    const start_r3_y = start_header_r3_y + height_header_r3 + 2;
    //const offset_r3_y = 9;
    // let current_r3_y = start_r2_y;

    const table_header_columns_refuel: any[] = [
      'Data',
      'Ora',
      'LitriCarburante',
      'Importo',
      'Km'
    ];
    let table_header_refuel = [];
    table_header_columns_refuel.forEach((column) => {
      table_header_refuel.push({
        id: column,
        name: column,
        prompt: column,
        width: 38,
        align: 'center',
        padding: 0
      });
    });

    let refillTableData = [];
    refills.forEach((refill) => {
      const dataRefill = this.dateHandler.formatDateClassic(refill.made_at);
      const oraRefill = this.dateHandler.formatTimeClassic(refill.made_at)
      const litriRefill = refill.quantity;
      const importoRefill = refill.amount;
      const kmRefill = refill.kilometers;
      refillTableData.push(
        {Data: dataRefill, Ora: oraRefill, LitriCarburante: litriRefill, Importo: importoRefill, Km: kmRefill}
      )
    });

    let current_r3_y = start_r3_y;
    doc.table(35, current_r3_y, refillTableData, table_header_refuel, {
      autoSize: false,
      printHeaders : true,
      fontSize : 5 ,
    });

    // *********RIQUADRO 4 - SEGNALAZIONI****************
    // *** Header r4
    const start_header_r4_y = current_r3_y + 63;
    const height_header_r4 = 7;

    doc.setDrawColor(0);
    doc.setFillColor(204, 0, 0);
    doc.rect(10, start_header_r4_y, 190, height_header_r4, 'F');

    doc.setFont(fontName, 'normal');
    doc.setTextColor(255, 255, 255);

    doc.setFontSize(10);
    doc.text('SEGNALAZIONI', 12,start_header_r4_y + 5, null, null, 'left');

    // *** Dati r4
    doc.setTextColor(0, 0, 0);
    doc.setFont(fontName, 'normal');
    doc.setFontSize(9);
    const start_r4_y = start_header_r4_y + height_header_r4 + 7;
    const offset_r4_y = 9;
    let current_r4_y = start_r4_y;
    const reporting = travel.reporting ? travel.reporting : '';
    doc.text(reporting, 20, current_r4_y);

    // *********RIQUADRO 5 - policy ****************
    // *** Header r5
    const start_header_r5_y = current_r4_y + 20;
    const offset_r5_y = 7;

    let current_r5_y = start_header_r5_y;
    doc.line(10, current_r5_y , 200, current_r5_y);
    // *** Dati r5

    doc.setTextColor(0, 0, 0);
    doc.setFont(fontName, 'normal');
    doc.setFontSize(6);
    current_r5_y = start_header_r5_y + offset_r5_y;
    doc.text('I dati riportati nel presente Certificato di Marcia ' +
      'sono estratti tramite procedure automatiche dal portale Roadmap.', 50, current_r5_y);

    doc.save(userName + '_' + this.dateHandler.formatDateClassic(new Date()) + '.pdf');

	}


  //*****************************************************************************************************************************
	//**********************PDF MILITARE********************************************************************************************
	showTravelPdfMilitare(travel, file) {

	  //DATI VIAGGIO
    const name = (travel.user && travel.user.name) ? travel.user.name : '';
    const surname = (travel.user && travel.user.surname) ? travel.user.surname : '';
    const user = name + ' ' + surname;
    const nomeParco = travel.vehicle.park.name;
    let altroConduttore = travel.other_drivers ? travel.other_drivers.toString() : '';
    let motivazione = this.determineMotivationOther(travel);
    const tipoVeicolo = travel.vehicle.type.name ? travel.vehicle.type.name.toString() : '';
    const targaVeicolo = travel.vehicle.plate;
    const dataInizio = formatDate(travel.started_at, 'dd/MM/yyyy HH:mm','en-US');
    const startKM = Math.floor(travel.start_kilometers);
    const endKM = Math.floor(travel.end_kilometers);
    const totKMpercorsi = endKM - startKM;

    //TRONCA LE STRINGHE TROPPO LUNGHE
    if(altroConduttore.length > 45) altroConduttore = altroConduttore.substring(0, 45);
    if(motivazione.length > 45) motivazione = motivazione.substring(0, 45);

    const doc = new jsPDF();

    //VARIABILI GRIGLIA
    const hcell = 10;

//allegato
    doc.setFontSize(10);
    doc.text('All. A al Cpt. 2 / CRM 14', 199, 18, null, null, 'right');

//PRIMA RIGA
    const ystart1 = 20

    doc.setFontSize(8);
    doc.rect(10, ystart1, 50, hcell*3);
    doc.text('N° D\'ORDINE',12,25);
    doc.text('',12,30);
    doc.text('LUOGO E DATA:',12,40);
    doc.text('Roma, ' + '',12,45);

    doc.rect(60, ystart1, 90, hcell*3);
    doc.setFontSize(12);
    doc.text('DOCUMENTO IMPIEGO MEZZI \(DIM\)',70,25);
    doc.text('\"CORPO MILITARE CRI\"',82,32);
    doc.setFontSize(10);
    doc.text('\"PARTE I - ORDINE DI SERVIZIO(1)',80,45);


    doc.rect(150, ystart1, 50, hcell*3);
    doc.addImage(file, "JPEG", 162, 23, 25, 25);
//FINE PRIMA RIGA

//RIGA
    doc.setFontSize(8);
    doc.rect(10, ystart1 + hcell*3, 50, hcell);
    doc.text('ENTE, DISTACCAMENTO O \nREPARTO CHE RILASCIA IL DIM',12,ystart1 + hcell*3+5);
    doc.rect(60, ystart1 + hcell*3, 45, hcell);
    doc.text(nomeParco,62,ystart1 + hcell*3+5);
    doc.rect(105, ystart1 + hcell*3, 45, hcell);
    doc.text('LUOGO PRESENTAZIONE',107,ystart1 + hcell*3+5);
    doc.rect(150, ystart1 + hcell*3, 50, hcell);
//FINE RIGA

//RIGA
    doc.setFontSize(8);
    doc.rect(10, ystart1 + hcell*4, 50, hcell);
    doc.text('CONDUTTORE/OPERATORE(2)',12,ystart1 + hcell*4+5);
    doc.rect(60, ystart1 + hcell*4, 45, hcell);
    doc.text(user,62,ystart1 + hcell*4+5);
    doc.rect(105, ystart1 + hcell*4, 45, hcell);
    doc.text('DESTINAZIONE',107,ystart1 + hcell*4+5);
    doc.rect(150, ystart1 + hcell*4, 50, hcell);
//FINE RIGA

//RIGA
    doc.setFontSize(8);
    doc.rect(10, ystart1 + hcell*5, 50, hcell);
    doc.text('CAPOMACCHINA/ \n2° CONDUTTORE(2)',12,ystart1 + hcell*5+5);
    doc.setFontSize(6);
    doc.rect(60, ystart1 + hcell*5, 45, hcell);
    doc.text(altroConduttore,62,ystart1 + hcell*5+5);
    doc.setFontSize(8);
    doc.rect(105, ystart1 + hcell*5, 45, hcell);
    doc.text('TIPO E MOTIVO DEL SERVIZIO',107,ystart1 + hcell*5+5);
    doc.setFontSize(6);
    doc.rect(150, ystart1 + hcell*5, 50, hcell);
    doc.text(motivazione,152,ystart1 + hcell*5+5);
//FINE RIGA

//RIGA
    doc.setFontSize(8);
    doc.rect(10, ystart1 + hcell*6, 50, hcell);
    doc.text('TIPO, TARGA O MATRICOLA \nVEICOLO',12,ystart1 + hcell*6+5);
    doc.rect(60, ystart1 + hcell*6, 45, hcell);
    doc.setFontSize(6);
    doc.text('TIPO:' + tipoVeicolo +'\nTARGA:' + targaVeicolo,62,ystart1 + hcell*6+5);
    doc.setFontSize(8);
    doc.rect(105, ystart1 + hcell*6, 45, hcell);
    doc.text('VALIDITA\' DIM (N. GIORNI)',107,ystart1 + hcell*6+5);
    doc.rect(150, ystart1 + hcell*6, 50, hcell);
//FINE RIGA

//RIGA
    doc.setFontSize(8);
    doc.rect(10, ystart1 + hcell*7, 50, hcell);
    doc.text('TIPO, TARGA O MATRICOLA \nRIMORCHIO',12,ystart1 + hcell*7+5);
    doc.rect(60, ystart1 + hcell*7, 45, hcell);
    doc.text('TIPO:\nTARGA:',62,ystart1 + hcell*7+5);
    doc.rect(105, ystart1 + hcell*7, 45, hcell);
    doc.text('PERSONALE O MATERIALE\nTRASPORTATO',107,ystart1 + hcell*7+5);
    doc.rect(150, ystart1 + hcell*7, 50, hcell);
//FINE RIGA

//RIGA
    doc.setFontSize(8);
    doc.rect(10, ystart1 + hcell*8, 50, hcell);
    doc.text('DATA E ORARIO INIZIO\nSERVIZIO',12,ystart1 + hcell*8+5);
    doc.rect(60, ystart1 + hcell*8, 45, hcell);
    doc.text(dataInizio,62,ystart1 + hcell*8+5);
    doc.rect(105, ystart1 + hcell*8, 45, hcell);
    doc.text('TIMBRO E FIRMA AUTORITÀ\nCHE DISPONE IL SERVIZIO',107,ystart1 + hcell*8+5);
    doc.rect(150, ystart1 + hcell*8, 50, hcell);
//FINE RIGA

//PARTE II

    const ystart2 = 112;
    const hcell2 = 9;

    doc.setFontSize(12);
    doc.rect(10, ystart2, 190, hcell2);
    doc.text('PARTE II - DATI RELATIVI AL SERVIZIO (3)',70,ystart2 +5);

    doc.setFontSize(10);
    doc.rect(10, ystart2 + hcell2, 140, hcell2);
    doc.text('PARTE IV - RIFORNIMENTI CARBURANTI',50,ystart2 + hcell2 +5);
    doc.setFontSize(8);
    doc.rect(150, ystart2 + hcell2, 50, hcell2*2);
    doc.text('FIRMA DEL CONDUTTORE,\nRESPONSABILE DEL\nRIFORNIMENTO',152,ystart2 + hcell2 +9);

    doc.rect(10, ystart2 + hcell2*2, 28, hcell2);
    doc.text('DATA',20,ystart2 + hcell2*2 +5);
    doc.rect(10+28, ystart2 + hcell2*2, 28, hcell2);
    doc.text('TIPO\nCARBURANTE',52,ystart2 + hcell2*2 +5,'center');
    doc.rect(10+28*2, ystart2 + hcell2*2, 28, hcell2);
    doc.text('LITRI RIFORNITI',69,ystart2 + hcell2*2 +5);
    doc.rect(10+28*3, ystart2 + hcell2*2, 28, hcell2);
    doc.text('TOTALE\nRIFORNITO',108,ystart2 + hcell2*2 +5,'center');
    doc.rect(10+28*4, ystart2 + hcell2*2, 28, hcell2);
    doc.text('AL KM',135,ystart2 + hcell2*2 +5,'center');

    doc.rect(10, ystart2 + hcell2*3, 28, hcell2);
    doc.rect(10+28, ystart2 + hcell2*3, 28, hcell2);
    doc.rect(10+28*2, ystart2 + hcell2*3, 28, hcell2);
    doc.rect(10+28*3, ystart2 + hcell2*3, 28, hcell2);
    doc.rect(10+28*4, ystart2 + hcell2*3, 28, hcell2);
    doc.rect(10+28*5, ystart2 + hcell2*3, 50, hcell2);

    doc.rect(10, ystart2 + hcell2*4, 28, hcell2);
    doc.rect(10+28, ystart2 + hcell2*4, 28, hcell2);
    doc.rect(10+28*2, ystart2 + hcell2*4, 28, hcell2);
    doc.rect(10+28*3, ystart2 + hcell2*4, 28, hcell2);
    doc.rect(10+28*4, ystart2 + hcell2*4, 28, hcell2);
    doc.rect(10+28*5, ystart2 + hcell2*4, 50, hcell2);

    doc.rect(10, ystart2 + hcell2*5, 28, hcell2);
    doc.rect(10+28, ystart2 + hcell2*5, 28, hcell2);
    doc.rect(10+28*2, ystart2 + hcell2*5, 28, hcell2);
    doc.rect(10+28*3, ystart2 + hcell2*5, 28, hcell2);
    doc.rect(10+28*4, ystart2 + hcell2*5, 28, hcell2);
    doc.rect(10+28*5, ystart2 + hcell2*5, 50, hcell2);

    doc.rect(10, ystart2 + hcell2*6, 28, hcell2);
    doc.rect(10+28, ystart2 + hcell2*6, 28, hcell2);
    doc.rect(10+28*2, ystart2 + hcell2*6, 28, hcell2);
    doc.rect(10+28*3, ystart2 + hcell2*6, 28, hcell2);
    doc.rect(10+28*4, ystart2 + hcell2*6, 28, hcell2);
    doc.rect(10+28*5, ystart2 + hcell2*6, 50, hcell2);

    doc.rect(10, ystart2 + hcell2*7, 28, hcell2);
    doc.rect(10+28, ystart2 + hcell2*7, 28, hcell2);
    doc.rect(10+28*2, ystart2 + hcell2*7, 28, hcell2);
    doc.rect(10+28*3, ystart2 + hcell2*7, 28, hcell2);
    doc.rect(10+28*4, ystart2 + hcell2*7, 28, hcell2);
    doc.rect(10+28*5, ystart2 + hcell2*7, 50, hcell2);

    doc.rect(10, ystart2 + hcell2*8, 28, hcell2);
    doc.rect(10+28, ystart2 + hcell2*8, 28, hcell2);
    doc.rect(10+28*2, ystart2 + hcell2*8, 28, hcell2);
    doc.rect(10+28*3, ystart2 + hcell2*8, 28, hcell2);
    doc.rect(10+28*4, ystart2 + hcell2*8, 28, hcell2);
    doc.rect(10+28*5, ystart2 + hcell2*8, 50, hcell2);

    doc.rect(10, ystart2 + hcell2*9, 28, hcell2);
    doc.rect(10+28, ystart2 + hcell2*9, 28, hcell2);
    doc.rect(10+28*2, ystart2 + hcell2*9, 28, hcell2);
    doc.rect(10+28*3, ystart2 + hcell2*9, 28, hcell2);
    doc.rect(10+28*4, ystart2 + hcell2*9, 28, hcell2);
    doc.rect(10+28*5, ystart2 + hcell2*9, 50, hcell2);


    doc.rect(10, ystart2 + hcell2*10, 28, hcell2);
    doc.rect(10+28, ystart2 + hcell2*10, 28, hcell2);
    doc.rect(10+28*2, ystart2 + hcell2*10, 28, hcell2);
    doc.rect(10+28*3, ystart2 + hcell2*10, 28, hcell2);
    doc.rect(10+28*4, ystart2 + hcell2*10, 28, hcell2);
    doc.rect(10+28*5, ystart2 + hcell2*10, 50, hcell2);

    doc.rect(10, ystart2 + hcell2*11, 28, hcell2);
    doc.rect(10+28, ystart2 + hcell2*11, 28, hcell2);
    doc.rect(10+28*2, ystart2 + hcell2*11, 28, hcell2);
    doc.rect(10+28*3, ystart2 + hcell2*11, 28, hcell2);
    doc.rect(10+28*4, ystart2 + hcell2*11, 28, hcell2);
    doc.rect(10+28*5, ystart2 + hcell2*11, 50, hcell2);



    doc.rect(10, ystart2 + hcell2*12, 140, hcell2*5);
    doc.text('ANNOTAZIONI, INCIDENTI E INEFFICIENZE DEL MEZZO (5)',12,ystart2 + hcell2*12 +5);

    doc.rect(150, ystart2 + hcell2*12, 50, hcell2);
    doc.text('Computo CONSUMI',160,ystart2 + hcell2*12 +5);

    doc.rect(150, ystart2 + hcell2*13, 30, hcell2);
    doc.text('Totale lt riforniti',152,ystart2 + hcell2*13 +5);
    doc.rect(180, ystart2 + hcell2*13, 20, hcell2);
    doc.rect(150, ystart2 + hcell2*14, 30, hcell2);
    doc.text('Totale Euro spesi',152,ystart2 + hcell2*14 +5);
    doc.rect(180, ystart2 + hcell2*14, 20, hcell2);
    doc.rect(150, ystart2 + hcell2*15, 30, hcell2);
    doc.text('Totale km percorsi',152,ystart2 + hcell2*15 +5);
    doc.rect(180, ystart2 + hcell2*15, 20, hcell2);
    doc.rect(150, ystart2 + hcell2*16, 30, hcell2);
    doc.text('Media Kilometrica',152,ystart2 + hcell2*16 +5);
    doc.rect(180, ystart2 + hcell2*16, 20, hcell2);


//FINE PARTE II
//NOTE
    const ystart3 = ystart2 + hcell2*17 +3;
    doc.text('1 Da compilare a cura di chi rilascia il DIM per i mezzi, sistemi e apparati, il cui utilizzo comporta un consumo di carburante.',10,ystart3);
    doc.text('2 Grado, cognome e nome. In caso di più di n. 2 conduttori, trascrivere i nominativi nelle annotazioni.',10,ystart3+3);
    doc.text('3 A cura del conduttore. Ove le righe per trascrivere i dati d\'impiego non siamo sufficienti, allegare un foglio con il n. d\'ordine e la data del DIM.',10,ystart3+6);
    doc.text('4 Il conduttore firmerà per il solo tragitto dalla caserma al luogo di presentazione e ritorno. Gli altri tragitti dovranno essere avallati, con apposizione della\nfirma, dall\'utente a bordo oppure dal responsabile del servizio (es. Capo Segreteria).',10,ystart3+9);
    doc.text('5 Il conduttore deve trascrivere nelle annotazioni, oltre eventuali incidenti e inefficenze del mezzo, eventi particolari occorsi durante il servizio, varianti\nall\'itinerario ecc. L\'Autorità che effettua il controllo del DIM, deve trascrivere e controfirmare nelle annotazioni eventuali anomalie riscontrate.',10,ystart3+15);

//RETRO SECONDA PAGINA
    doc.addPage();

    //allegato
    doc.setFontSize(10);
    doc.text('All. A al Cpt. 2', 199, 18, null, null, 'right');

    doc.setFontSize(8);
    doc.rect(10, ystart1, 50, hcell*3);
    doc.text('N° D\'ORDINE',12,25);
    doc.text('',12,30);
    doc.text('LUOGO E DATA:',12,40);
    doc.text('Roma, ' + '',12,45);

    doc.rect(60, ystart1, 90, hcell*3);
    doc.setFontSize(12);
    doc.text('DOCUMENTO IMPIEGO MEZZI \(DIM\)',70,25);
    doc.text('INTERCALARE',90,32);

    doc.rect(150, ystart1, 50, hcell*3);
    doc.addImage(file, "JPEG", 162, 23, 25, 25);
//FINE PRIMA RIGA

//RIGA
    let row2=3;
    doc.setFontSize(9);
    doc.rect(10, ystart1 + hcell*row2, 50, hcell);
    doc.text('PARTENZA / INIZIO SERVIZIO',11,ystart1 + hcell*3+5);
    doc.rect(60, ystart1 + hcell*row2, 90, hcell);
    doc.text('ARRIVO / TERMINE SERVIZIO',80,ystart1 + hcell*3+5);
    doc.rect(150, ystart1 + hcell*row2, 50, hcell*2);
    doc.text('FIRMA DEL CONDUTTORE,\nDELL\' UTENTE O DEL\nRESPONSABILE DEL\nSERVIZIO',175,ystart1 + hcell*row2+5,'center');
//FINE RIGA

//RIGA
    row2++;
    doc.setFontSize(8);
    doc.rect(10, ystart1 + hcell*row2, 16, hcell);
    doc.text('DATA',12,ystart1 + hcell*row2+5);
    doc.rect(26, ystart1 + hcell*row2, 16, hcell);
    doc.text('ORA',29,ystart1 + hcell*row2+5);
    doc.rect(42, ystart1 + hcell*row2, 18, hcell);
    doc.text('LUOGO\nPARTENZA',50,ystart1 + hcell*row2+5,'center');

    doc.rect(60, ystart1 + hcell*row2, 16, hcell);
    doc.text('DATA',63,ystart1 + hcell*row2+5);
    doc.rect(76, ystart1 + hcell*row2, 16, hcell);
    doc.text('ORA',79,ystart1 + hcell*row2+5);
    doc.rect(92, ystart1 + hcell*row2, 29, hcell);
    doc.text('LUOGO\nARRIVO',100,ystart1 + hcell*row2+5);
    doc.rect(121, ystart1 + hcell*row2, 29, hcell);
    doc.text('KM ARRIVO',128,ystart1 + hcell*row2+5);

//RIGHE FOR
    row2++;
    doc.setFontSize(8);
    for(let rx=row2;rx<22;rx++){
      doc.rect(10, ystart1 + hcell*rx, 16, hcell);
      doc.rect(26, ystart1 + hcell*rx, 16, hcell);
      doc.rect(42, ystart1 + hcell*rx, 18, hcell);

      doc.rect(60, ystart1 + hcell*rx, 16, hcell);
      doc.rect(76, ystart1 + hcell*rx, 16, hcell);
      doc.rect(92, ystart1 + hcell*rx, 29, hcell);
      doc.rect(121, ystart1 + hcell*rx, 29, hcell);

      doc.rect(150, ystart1 + hcell*rx, 50, hcell);

    }
// FINE RIGHE FOR

//RIGA
    row2 = 21;
    let ystart4 = 245;

    doc.rect(10, ystart4, 140, hcell2*4);
    doc.text('ANNOTAZIONI, INCIDENTI E INEFFICIENZE DEL MEZZO',12,ystart4+5);

    doc.rect(150, ystart4, 50, hcell2);
    doc.text('Computo percorrenza',160,ystart4 +5);

    doc.rect(150, ystart4+ hcell2, 30, hcell2);
    doc.text('Km alla partenza',152,ystart4 + hcell2 +5);
    doc.rect(180, ystart4+ hcell2, 20, hcell2);
    doc.text(startKM.toString(),182,ystart4 + hcell2 +5);

    doc.rect(150, ystart4+ hcell2*2, 30, hcell2);
    doc.text('Km a fine servizio',152,ystart4 + hcell2*2 +5);
    doc.rect(180, ystart4+ hcell2*2, 20, hcell2);
    doc.text(endKM.toString(),182,ystart4 + hcell2*2 +5);

    doc.rect(150, ystart4+ hcell2*3, 30, hcell2);
    doc.text('Totale km percorsi',152,ystart4 + hcell2*3 +5);
    doc.rect(180, ystart4+ hcell2*3, 20, hcell2);
    doc.text(totKMpercorsi.toString(),182,ystart4 + hcell2*3 +5);

//FINE RIGA


    doc.save(user + '_' + this.dateHandler.formatDateClassic(new Date()) + '.pdf');
  }


  rimuoviAccapo(input: string): string {
    return input.replace(/[\r\n]+/g, ' '); // Rimuove tutti i \r e \n
  }
}
